module.exports = __webpack_public_path__ + "img/Maestro.425e45a4.svg";